import React from "react";
import ReactDOM from "react-dom";
import { Provider, connect } from "react-redux";

import Context from "../../../../../context/Context";
import SidebarHeader from "../../../Sidebar/SidebarHeader";
import Rdx from "../../../../../redux/Rdx";
import Topic from "../../../../../context/Topic";
import Icons from "../../../../util/Icons";
import DurationFilters from "./DurationFilters";
import SpaceFilters from "./SpaceFilters";
import * as component from "../../../../util/component";
import { getLoggedInUser, login, areEmailsAvailable} from "./OfficeHotelingInterface";
import Office365 from "./Office365";
import Loader from 'calcite-react/Loader/Loader';
import * as focusUtil from "../../../../../util/focusUtil";
import ItemReference from "../../../../../aiim/base/ItemReference";
import { ModalController } from "../../../../../common/components/Modal";

const CSS = {
  optionsContainer: "i-hotel-list-filters i-events-options-container",
  options: "i-events-options",
  filterButton: "i-filter-button",
  ddButton: "i-dd-button",
  units: "i-available-units",
  description: "i-filter-description",
  sidebarPanelOpen: "i-sidebar-panel-open",
  unitsList: "i-available-units-list",
  hotelscroll: "i-hotelscroll",
  hotels: "i-hotels"
}
//let COUNTER = 0

class BookWorkspace extends React.Component {
  _mounted = false
  listRef = React.createRef()

  constructor(props) {
    super(props)
    //this.id = COUNTER++
    this.state = component.newState({
      isWorking: true,
      isQuerying: true,
      spaceTypeFilters: [],
      areaFilters: [],
      units: [],
      areas: []
    })
  }

  componentWillUnmount() {
    this._mounted = false
    component.componentWillUnmount(this)
  }

  componentDidMount() {
    this._mounted = true
    Context.instance.hotelingUnits.then(units => {
      Context.instance.areas.then(areas => {
        console.log(units)
        console.log(areas)
        let spaceTypeFilters = []
        units.forEach(unit => {
          const spaceType = unit.attributes.USE_TYPE || unit.attributes.use_type
          if (!spaceTypeFilters.includes(spaceType)) spaceTypeFilters.push(spaceType)
        })
        let areaFilters = []
        areas.forEach(area => {
          const name = area.attributes.AREA_NAME || area.attributes.area_name
          if (!areaFilters.includes(name)) areaFilters.push(name)
        })
        this.setState({
          isWorking: false,
          spaceTypeFilters: spaceTypeFilters,
          areaFilters: areaFilters,
          units: units,
          areas: areas
        })
      }).catch(error => {
        this.setState({
          isWorking: false,
          spaceTypeFilters: [],
          areaFilters: [],
          units: [],
          areas: []
        })
        this.closePanel()
      })
    }).catch(error => {
      this.setState({
        isWorking: false,
        spaceTypeFilters: [],
        areaFilters: [],
        units: [],
        areas: []
      })
      this.closePanel()
    })

    // Load data here
    component.own(this, [
      Topic.subscribe(Topic.BookingFiltersSubmit, params => {
        const applyFilters = () => {
          this.setState({
            isQuerying: true
          })
          const selectedSpaceTypeFilters = this.props.rdxSpaceTypeFilters
          const selectedAreaFilters = this.props.rdxAreaFilters
          const bookingSystem = Office365.getInstance()

          const units = this.state.units
          const areas = this.state.areas

          // Map Area IDs to Area Names
          let areaNames = {}
          areas.forEach(area => {
            const name = area.attributes.AREA_NAME || area.attributes.area_name
            const id = area.attributes.AREA_ID || area.attributes.area_id
            areaNames[id] = name
          })

          // Filter through units
          let filteredUnits = []
          let filteredUnitsNoEmail = []
          let scheduleEmails = []
          units.forEach(unit => {
            const spaceType = unit.attributes.USE_TYPE || unit.attributes.use_type
            const areaId = unit.attributes.AREA_ID || unit.attributes.area_id
            const areaName = areaId && areaNames[areaId]
            const scheduleEmail = unit.attributes.SCHEDULE_EMAIL || unit.attributes.schedule_email
            if (spaceType && areaId && areaName) {
              if (selectedSpaceTypeFilters.length === 0 && selectedAreaFilters.length === 0) {
                if (scheduleEmail) {
                  filteredUnits.push(unit)
                  scheduleEmails.push(scheduleEmail)
                } else {
                  filteredUnitsNoEmail.push(unit)
                }
              } else if (selectedSpaceTypeFilters.length === 0) {
                if (selectedAreaFilters.includes(areaName)) {
                  if (scheduleEmail) {
                    filteredUnits.push(unit)
                    scheduleEmails.push(scheduleEmail)
                  } else {
                    filteredUnitsNoEmail.push(unit)
                  }
                }
              } else if (selectedAreaFilters.length === 0) {
                if (selectedSpaceTypeFilters.includes(spaceType)) {
                  if (scheduleEmail) {
                    filteredUnits.push(unit)
                    scheduleEmails.push(scheduleEmail)
                  } else {
                    filteredUnitsNoEmail.push(unit)
                  }
                }
              } else if (selectedSpaceTypeFilters.includes(spaceType) &&
                         selectedAreaFilters.includes(areaName)) {
                if (scheduleEmail) {
                  filteredUnits.push(unit)
                  scheduleEmails.push(scheduleEmail)
                } else {
                  filteredUnitsNoEmail.push(unit)
                }
              }
            }
          })
          Rdx.setValue(this, Rdx.Keys.BOOK_FILTERED_RESULTS_NO_EMAIL, filteredUnitsNoEmail)

          console.log("FILTERED", filteredUnits, scheduleEmails)
          const checkIn = this.props.rdxCheckIn
          const checkOut = this.props.rdxCheckOut

          // Query for schedules
          if (scheduleEmails.length === 0) {
            this.setState({
              isQuerying: false
            })
            Rdx.setValue(this, Rdx.Keys.BOOK_FILTERED_RESULTS, [])
          } else {
            let user = getLoggedInUser(bookingSystem)
            if (user) {
              areEmailsAvailable(bookingSystem, scheduleEmails, checkIn, checkOut).then(finalResults => {
                const results = [].concat.apply([], finalResults)
                console.log("RESULTS", results)
                this.setState({
                  isQuerying: false
                })
                Rdx.setValue(this, Rdx.Keys.BOOK_FILTERED_RESULTS, results)
              }).catch(e => {
                console.error(e)
                ModalController.showMessage(e)
              })
            } else {
              login(bookingSystem).then(result => {
                this.areEmailsAvailable(bookingSystem, scheduleEmails, checkIn, checkOut).then(finalResults => {
                  const results = [].concat.apply([], finalResults)
                  console.log("RESULTS", results)
                  this.setState({
                    isQuerying: false
                  })
                  Rdx.setValue(this, Rdx.Keys.BOOK_FILTERED_RESULTS, results)
                }).catch(e => {
                  console.error(e)
                  ModalController.showMessage(e)
                })
              }).catch(e => {
                console.error(e)
                ModalController.showMessage(e)
              })
            }
          }
        }

        if (this._mounted) {
          setTimeout(applyFilters, 500)
        }
      })
    ])
  }

  componentDidUpdate() {
    if (!this.state.isQuerying) {
      if (this.listRef && this.listRef.current &&
          this.listRef.current.cardRef && this.listRef.current.cardRef.current) {
        this.listRef.current.cardRef.current.focus()
      }
    }
  }

  // _getFocusables = () => {
  //   let nodes = [];
  //   const units = document.getElementById("available-units");
  //   const duration = document.getElementById("btn-durationfilter")
  //   const filter = document.getElementById("btn-spacefilter")
  //   const refresh = document.getElementById("btn-refresh")

  //   if (units) {
  //     units.querySelectorAll("button").forEach(unit => {
  //       nodes.push(unit)
  //     })
  //   }
  //   nodes.push(refresh)
  //   nodes.push(filter)
  //   nodes.push(duration)
  //   return nodes;
  // }

  // _focusButton = () => {
  //   const node = document.getElementById(this.id+"-btn");
  //   focusUtil.focusNode(node);
  // }

  // _focusStep = (event, direction, isTabShift) => {
  //   let nodes = this._getFocusables();
  //   if (nodes && nodes.length > 1) {
  //     let info = focusUtil.findTarget(nodes,event.target);
  //     let index = (direction === "previous")? info.previousIndex: info.nextIndex;
  //     if (index !== -1) {
  //       if (isTabShift && info.index === 0) {
  //         this._focusButton();
  //       } else {
  //         focusUtil.focusIndex(nodes,index);
  //       }
  //     }
  //   }
  // }

  // _keydownContent = (event) => {
  //   if (event) {
  //     if (event.keyCode === 9) { // tab
  //       event.preventDefault();
  //       event.stopPropagation();
  //       const dir = event.shiftKey? "previous": "next";
  //       this._focusStep(event,dir,!!event.shiftKey);
  //     } else if (event.keyCode === 38) { // up arrow
  //       event.preventDefault();
  //       event.stopPropagation();
  //       this._focusStep(event,"previous");
  //     } else if (event.keyCode === 40) { // down arrow
  //       event.preventDefault();
  //       event.stopPropagation();
  //       this._focusStep(event,"next");
  //     }
  //   }
  // }

  closePanel() {
    Rdx.setValue(this, Rdx.Keys.SIDEBAR_ACTIVE_KEY, null);
    document.body.classList.remove(CSS.sidebarPanelOpen);
    Context.instance.views.toggleClickHandlers("resume");
  }

  backClicked = () => {
    Rdx.setValue(this,Rdx.Keys.SIDEBAR_ACTIVE_KEY, "more");
    document.body.classList.add(CSS.sidebarPanelOpen);
    Topic.publish(Topic.SidebarButtonClicked,{sidebarKey: "more"});
    Context.instance.views.toggleClickHandlers("resume");
  }

  showDurationPopup = () => {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <Provider store={Rdx.store}>
        <DurationFilters initialFilter={false} closePopup={onClose} />
      </Provider>
    ), node);
  }

  showSpacePopup = () => {
    const node = document.createElement("div");
    document.body.appendChild(node);

    const onClose = () => {
      if (node && node.parentNode) {
        node.parentNode.removeChild(node);
        ReactDOM.unmountComponentAtNode(node)
      }
    };

    ReactDOM.render((
      <Provider store={Rdx.store}>
        <SpaceFilters initialFilter={false} closePopup={onClose}
          spaceTypeFilters={this.state.spaceTypeFilters}
          areaFilters={this.state.areaFilters} />
      </Provider>
    ), node);
  }

  refresh = () => {
    Topic.publish(Topic.BookingFiltersSubmit, {})
  }

  renderHeader() {
    const i18n = Context.getInstance().i18n;
    return <SidebarHeader caption={i18n.more.bookWorkspace.caption}
      closeAriaLabel={i18n.more.bookWorkspace.closeAriaLabel}
      sidebarKey={this.props.sidebarKey} showBack={!!this.props.morePanel} backHandler={this.backClicked}/>
  }

  renderOptions() {
    const i18n = Context.instance.i18n
    return (
      <div className={CSS.optionsContainer}>
        <div key="datetime" className={CSS.options}>
          <div className={CSS.filterButton}>
            <button id="btn-durationfilter" aria-label={i18n.more.bookWorkspace.durationAriaLabel}
              className={CSS.ddButton} onClick={this.showDurationPopup}>
              {i18n.more.bookWorkspace.duration}
            </button>
          </div>
          <div className={CSS.filterButton}>
            <button id="btn-spacefilter" aria-label={i18n.more.bookWorkspace.filterAriaLabel}
              className={CSS.ddButton} onClick={this.showSpacePopup}>
              {i18n.more.bookWorkspace.filter}
            </button>
          </div>
          {
            (this.props.rdxCheckIn && this.props.rdxCheckOut) ?
              <div className={CSS.filterButton + " i-refresh"}>
                <button id="btn-refresh" title={i18n.more.bookWorkspace.refresh}
                  aria-label={i18n.more.bookWorkspace.refreshAriaLabel} className={CSS.ddButton} onClick={this.refresh}>
                  {Icons.reload()}
                </button>
              </div> : null
          }
        </div>
      </div>
    );
  }

  scheduleIdToUnit(scheduleId) {
    const units = this.state.units
    const areas = this.state.areas

    // Map Area IDs to Area Names
    let areaNames = {}
    areas.forEach(area => {
      const name = area.attributes.AREA_NAME || area.attributes.area_name
      const id = area.attributes.AREA_ID || area.attributes.area_id
      areaNames[id] = name
    })

    let result = null
    units.forEach(unit => {
      const scheduleEmail = unit.attributes.SCHEDULE_EMAIL || unit.attributes.schedule_email
      if (scheduleEmail === scheduleId) {
        const spaceType = unit.attributes.USE_TYPE || unit.attributes.use_type
        const areaId = unit.attributes.AREA_ID || unit.attributes.area_id
        const areaName = areaId && areaNames[areaId]
        const name = unit.attributes.NAME || unit.attributes.name
        const level = unit.attributes.LEVEL_NAME || unit.attributes.level_name
        const facility = unit.attributes.FACILITY_NAME || unit.attributes.facility_name
        if (spaceType && areaName && name && level && facility) {
          result = {
            spaceType: spaceType,
            areaName: areaName,
            name: name,
            level: level,
            facility: facility,
            searchResult: unit
          }
        }
      }
    })
    return result
  }

  renderCards() {
    const i18n = Context.instance.i18n
    const schedules = this.props.rdxFilteredResults
    const noEmails = this.props.rdxFilteredResultsNoEmail
    const data = schedules
    let cards = []
    if (data) {
      data.forEach(unit => {
        if (unit.scheduleItems) {
          const isAvailable = unit.scheduleItems.length === 0
          if (isAvailable) {
            const matchingUnit = this.scheduleIdToUnit(unit.scheduleId)
            if (matchingUnit) {
              const spaceType = matchingUnit.spaceType
              const name = matchingUnit.name
              const level = matchingUnit.level
              const facility = matchingUnit.facility
              const searchResult = matchingUnit.searchResult
              let description = i18n.more.bookWorkspace.unitDescription
              description = description.replace("{level}", level)
              description = description.replace("{facility}", facility)
              // const targetId = this.id + "-btn"
              if (cards.length === 0) {
                cards.push(
                  <AvailableUnitCard
                    // id={targetId}
                    key={unit.scheduleId}
                    name={name}
                    spaceType={spaceType}
                    description={description}
                    hasEmail={true}
                    unit={searchResult}
                    ref={this.listRef} />
                )
              } else {
                cards.push(
                  <AvailableUnitCard
                    // id={targetId}
                    key={unit.scheduleId}
                    name={name}
                    spaceType={spaceType}
                    description={description}
                    hasEmail={true}
                    unit={searchResult} />
                )
              }
            }
          }
        } else {
          console.log("Not a valid email")
          const matchingUnit = this.scheduleIdToUnit(unit.scheduleId)
          console.log(matchingUnit)
          noEmails.push(matchingUnit.searchResult)
        }
      })
    }

    noEmails.forEach(unit => {
      const areas = this.state.areas
      const id = unit.attributes.UNIT_ID || unit.attributes.unit_id

      // Map Area IDs to Area Names
      let areaNames = {}
      areas.forEach(area => {
        const name = area.attributes.AREA_NAME || area.attributes.area_name
        const id = area.attributes.AREA_ID || area.attributes.area_id
        areaNames[id] = name
      })

      const spaceType = unit.attributes.USE_TYPE || unit.attributes.use_type
      const name = unit.attributes.NAME || unit.attributes.name
      const level = unit.attributes.LEVEL_NAME || unit.attributes.level_name
      const facility = unit.attributes.FACILITY_NAME || unit.attributes.facility_name
      if (spaceType && name && level && facility) {
        let description = i18n.more.bookWorkspace.unitDescription
        description = description.replace("{level}", level)
        description = description.replace("{facility}", facility)
        // const targetId = this.id + "-btn"
        if (cards.length === 0) {
          cards.push(
            <AvailableUnitCard
              // id={targetId}
              key={id}
              name={name}
              spaceType={spaceType}
              description={description}
              hasEmail={false}
              unit={unit}
              ref={this.listRef} />
          )
        } else {
          cards.push(
            <AvailableUnitCard
              // id={targetId}
              key={id}
              name={name}
              spaceType={spaceType}
              description={description}
              hasEmail={false}
              unit={unit} />
          )
        }
      }
    })

    const noItems = i18n.more.bookWorkspace.noUnits
    const allDay = this.props.rdxAllDay
    const lib = Context.instance.lib
    const today = lib.dojo.locale.format(new Date(), { selector:"date", formatLength:"short" })
    const startDate = lib.dojo.locale.format(this.props.rdxStartDate, { selector:"date", formatLength:"short" })
    const endDate = lib.dojo.locale.format(this.props.rdxEndDate, { selector:"date", formatLength:"short" })
    let areItems
    if (allDay) {
      let dur, day
      if (startDate === today && endDate === today) {
        dur = ""
        day = i18n.more.bookWorkspace.today
      } else if (startDate === endDate) {
        dur = i18n.more.bookWorkspace.on
        day = startDate
      } else {
        dur = i18n.more.bookWorkspace.from
        day = startDate + " - " + endDate
      }
      areItems = i18n.more.bookWorkspace.availableUnitsAllDay
      areItems = areItems.replace("{duration}", dur)
      areItems = areItems.replace("{day}", day)
    } else {
      let date, st, et, dur
      if (startDate === endDate) {
        date = startDate
        dur = i18n.more.bookWorkspace.on
      } else {
        date = startDate + " - " + endDate
        dur = i18n.more.bookWorkspace.from
      }
      let locale = Context.instance.lib.dojo.kernel.locale
      let format
      if (locale === "en" || locale === "en-us") {
        format = "h:mm A"
      } else {
        format = "H:mm"
      }
      st = this.props.rdxStartTime.format(format)
      et = this.props.rdxEndTime.format(format)
      areItems = i18n.more.bookWorkspace.availableUnits
      areItems = areItems.replace("{duration}", dur)
      areItems = areItems.replace("{date}", date)
      areItems = areItems.replace("{startTime}", st)
      areItems = areItems.replace("{endTime}", et)
    }
    return (
      <div className={CSS.unitsList}>
        <div className={CSS.description}>
          {this.state.isQuerying ? i18n.more.bookWorkspace.searching : (cards.length > 0) ? areItems : noItems}
        </div>
        {
          this.state.isQuerying ? <Loader sizeRatio={1} style={{marginTop: '3rem'}} /> :
          <div id="available-units" role="none" className={CSS.units}
          // onKeyDown={this._keydownContent}
          >
            {cards}
          </div>
        }
      </div>
    )
  }

  render() {
    if (this.state.isWorking) {
      return null
    } else {
      return (
        <div className={CSS.hotels}>
          {this.renderHeader()}
            <div className={CSS.hotelscroll}>
              {this.renderOptions()}
              {this.renderCards()}
            </div>
        </div>
      )
    }
  }
}

const mapStateToProps = (state) => {
  return {
    rdxSidebarActiveKey: Rdx.getValue(state, Rdx.Keys.SIDEBAR_ACTIVE_KEY),
    rdxCheckIn: Rdx.getValue(state, Rdx.Keys.BOOK_CHECKIN),
    rdxCheckOut: Rdx.getValue(state, Rdx.Keys.BOOK_CHECKOUT),
    rdxStartDate: Rdx.getValue(state, Rdx.Keys.BOOK_DATEFILTER_STARTSELECTED),
    rdxEndDate: Rdx.getValue(state, Rdx.Keys.BOOK_DATEFILTER_ENDSELECTED),
    rdxStartTime: Rdx.getValue(state, Rdx.Keys.BOOK_TIMEFILTER_STARTSELECTED),
    rdxEndTime: Rdx.getValue(state, Rdx.Keys.BOOK_TIMEFILTER_ENDSELECTED),
    rdxAllDay: Rdx.getValue(state, Rdx.Keys.BOOK_ALLDAY),
    rdxSpaceTypeFilters: Rdx.getValue(state, Rdx.Keys.SPACETYPE_FILTERS),
    rdxAreaFilters: Rdx.getValue(state, Rdx.Keys.AREA_FILTERS),
    rdxFilteredResults: Rdx.getValue(state, Rdx.Keys.BOOK_FILTERED_RESULTS),
    rdxFilteredResultsNoEmail: Rdx.getValue(state, Rdx.Keys.BOOK_FILTERED_RESULTS_NO_EMAIL)
  }
}

export default connect(mapStateToProps)(BookWorkspace);

/* - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - - -  */
const CardCSS = {
  main: "i-available-unit",
  title: "i-title",
  unitInfo: "i-unit-info",
  spaceType: "i-space-type"
}

class AvailableUnitCard extends React.Component {
  // NAME, FACILITY_NAME, LEVEL_NAME, Space Type
  constructor(props) {
    super(props)
    this.cardRef = React.createRef()
  }

  onClick = () => {
    const source = Context.instance.aiim.datasets.units.getSource()
    const feature = this.props.unit
    const item = new ItemReference()
    item.fromSearchResult(source.key, {feature: feature})
    Topic.publish(Topic.ShowSearchResult, {
      sourceKey: source.key,
      searchResult: item.searchResult,
      zoom: true,
      highlight: true,
      trackRecent: true,
      isBookWorkspacePanel: true
    })
    if (!this.props.hasEmail) {
      const i18n = Context.instance.i18n
      let msg = i18n.more.bookWorkspace.missingEmail
      msg = msg.replace("{unitName}", this.props.name)
      ModalController.showMessage(msg)
    }
  }

  render() {
    const mainCSS = this.props.hasEmail ? CardCSS.main : CardCSS.main + " no-email"
    const pinIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#pin-16"
    // const deskIcon = "libs/calcite-ui-icons/icons/sprite-16.svg#desk-16"
    return (
      <button className={mainCSS} onClick={this.onClick} ref={this.cardRef}>
        <div className={CardCSS.title}>{this.props.name}</div>
        <div className={CardCSS.unitInfo}>
          <svg><use href={pinIcon}></use></svg>
          <div>{this.props.description}</div>
        </div>
        <div className={CardCSS.spaceType}>
          {Icons.desk()}
          <div>{this.props.spaceType}</div>
        </div>
      </button>
    )
  }
}
